__turbopack_context__.v({
  "accordionSlideOverwrite": "cancellationCard-module-scss-module__E8Esiq__accordionSlideOverwrite",
  "cancellationCard": "cancellationCard-module-scss-module__E8Esiq__cancellationCard",
  "fadeIn": "cancellationCard-module-scss-module__E8Esiq__fadeIn",
  "fadeOut": "cancellationCard-module-scss-module__E8Esiq__fadeOut",
  "highlight": "cancellationCard-module-scss-module__E8Esiq__highlight",
  "scaleIn": "cancellationCard-module-scss-module__E8Esiq__scaleIn",
  "scaleOut": "cancellationCard-module-scss-module__E8Esiq__scaleOut",
  "title": "cancellationCard-module-scss-module__E8Esiq__title",
  "zoomIn": "cancellationCard-module-scss-module__E8Esiq__zoomIn",
  "zoomOut": "cancellationCard-module-scss-module__E8Esiq__zoomOut",
});
